<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Listado de precios" :extraText="extraText" />
        </div>
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Listado de precios</h3>
                                <div class="card-tools">
                                    <Button @click="showModal('crearDescuento')">Crear nuevo precio</Button>
                                    <CreateDescuentoModal :lista_id="$store.getters.getListaId" :precio_id="precio_id" v-on:close="closeModal"/>
                                </div>
                            </div>

                            <div class="card-header">
                                <div class="row justify-content-between">
                                    <div class="col-4">
                                        <div class="input-group input-group-sm">
                                            <input type="text" name="table_search" class="form-control" placeholder="Buscar" v-model="filters.search"/>

                                            <div class="input-group-append">
                                                <Button type="submit" variant="default" icon="fas fa-search" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    
                            <div class="card-body">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Precio</th>
                                            <th>Edad mínima</th>
                                            <th>Edad máxima</th>
                                            <th>Venta online</th>
                                            <th>Renovación</th>
                                            <th>Color</th>
                                            <th class="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!loading">
                                        <template v-for="(descuento, index) in descuentos">
                                            <tr :key="index">
                                                <td>{{ descuento.descripcion }}</td>
                                                <td>
                                                    <ul>
                                                        <li>
                                                            Online: {{ parseFloat(descuento.precio_total_online) | formatear_precio }}
                                                        </li>
                                                
                                                        <li>
                                                            Taquilla: {{ parseFloat(descuento.precio_total_taquilla) | formatear_precio }}
                                                        </li>
                                                    </ul>
                                                </td>
                                                <td>{{ descuento.edad_minima || descuento.fecha_nacimiento_minima }}</td>
                                                <td>{{ descuento.edad_maxima || descuento.fecha_nacimiento_maxima }}</td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="descuento.show_online"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="descuento.renovacion"/>
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        :style="{
                                                            backgroundColor: descuento.color ?? '#000000',
                                                            width: '20px',
                                                            height: '20px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #ccc',
                                                            display: 'inline-block'
                                                        }"
                                                        :title="descuento.color"
                                                    ></div>
                                                </td>
                                                <td class="text-center">
                                                    <div :class="'btn-group ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                                        <Button type="button" class="dropdown-toggle" @click.prevent="expandir(index)">OPCIONES</Button>
                                                        <div :class="'dropdown-menu ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                                            <a href="#" class="dropdown-item" @click.prevent="showModal('editarDescuento-' + descuento.id)">Editar</a>
                                                            <a href="#" class="dropdown-item" @click.prevent="showModal('borrar-' + descuento.id)">Borrar</a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <EditarDescuentoModal :key="index + '-'" :precio_id="precio_id" :lista_id="$store.getters.getListaId" :descuento="descuento" v-on:close="closeModal"/>
                                            <DeleteDescuentoModal :key="index + '--'" :precio_id="precio_id" :lista_id="$store.getters.getListaId" :descuento="descuento" v-on:close="closeModal"/>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="5">
                                                <LoaderComponent/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script>
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import CreateDescuentoModal from './modals/CreateDescuentoModal';
    import EditarDescuentoModal from './modals/EditDescuentoModal';
    import DeleteDescuentoModal from './modals/DeleteDescuentoModal';
    import CheckOrCross from "../../../../components/backend/components/CheckOrCross";

    export default {
        props: ['precio_id'],
        data() {
            return {
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                extraText: '',
                expand: [],
                descuentos: null
            }
        },
        created() {
            this.getDescuentos();
        },
        methods: {
            getDescuentos : function() {
                this.loading = true;
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId,
                    precio_id: this.precio_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.descuentos'), params).then(res => {
                    this.descuentos = res.data.data;
                    if (this.descuentos?.length) {
                        this.extraText = this.descuentos[0].descripcion_tipo_abono + (this.descuentos[0].renovacion_tipo_abono ? ' (RENOVACIÓN)' : '');
                    }
                    this.loading = false;
                });
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.expand = [];

                if(creado) {
                    this.getDescuentos();
                }

                this.$modal.hide(modal);
            }
        },
        components: {
            CheckOrCross, PageTitleComponent, LoaderComponent, CreateDescuentoModal,
            EditarDescuentoModal, DeleteDescuentoModal
        }
    }
</script>